import { isEmpty } from 'lodash';

import { useQueryIntegrationNames } from '@ion/api';

import { alphabetizeBy } from '@ion/mrdash';

import {
  useEventDebuggerTableContext,
  FILTER_KEYS,
} from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

const STATIC_INTEGRATION_SELECT_PROPS = {
  label: 'Integrations',
  size: 'small',
  variant: 'outlined',
};

export default function useEventDebuggerIntegrationsSelect() {
  const { cluster, filters, filterOptions, filterOptionsLoading, updateFilter } = useEventDebuggerTableContext();
  const { integrations } = useQueryIntegrationNames();

  const onChange = selectedIntegrations => {
    updateFilter({ [FILTER_KEYS.INTEGRATION_IDS]: selectedIntegrations });
  };

  const props = {
    ...STATIC_INTEGRATION_SELECT_PROPS,
    options: buildOptions(
      withSelectedIntegrations({
        integrationsWithEvents: filterOptions?.integrations,
        selectedIds: filters[FILTER_KEYS.INTEGRATION_IDS],
        integrations,
      })
    ),
    disabled: filterOptionsLoading || !cluster,
    key: `${cluster}-integrations`,
    value: filters[FILTER_KEYS.INTEGRATION_IDS],
    onChange,
  };

  return props;
}

// A deep link can select an integration with no recent events. Keep it as an option so the
// select shows what the table is filtered to.
function withSelectedIntegrations({ integrationsWithEvents = [], selectedIds, integrations }) {
  const isMissing = integration =>
    selectedIds.includes(integration.id) && !integrationsWithEvents.some(({ id }) => id === integration.id);

  return [...integrationsWithEvents, ...integrations.filter(isMissing)];
}

function buildOptions(integrations) {
  if (isEmpty(integrations)) {
    return [{ label: 'No integrations available', value: '', disabled: true }];
  }

  const sortedIntegrations = alphabetizeBy(integrations, 'name');

  return sortedIntegrations.map(integration => ({
    label: integration.name,
    value: integration.id,
  }));
}
